module.exports = __webpack_public_path__ + "img/156740814737337x3vk.1e9c8062.png";